(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["finstark-triple-gallery"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const root = document.currentScript.closest('section');
    const list = root && root.querySelector('.tri-strip__list');
    if (!list) return;

    const mode = list.getAttribute('data-mobile-mode');
    const dotsWrap = root.querySelector('.tri-strip__dots');
    const autoplay = list.getAttribute('data-autoplay') === 'true';
    const speed = parseInt(list.getAttribute('data-autoplay-speed') || '3500', 10);

    function isMobile(){ return window.matchMedia('(max-width: 767px)').matches; }

    if (mode === 'carousel' && isMobile()) {
      const items = Array.from(list.children);

      // Dots
      if (dotsWrap) {
        dotsWrap.innerHTML = items.map((_,i)=>`<button type="button" aria-current="${i===0?'true':'false'}" aria-label="Go to slide ${i+1}"></button>`).join('');
        const dots = Array.from(dotsWrap.querySelectorAll('button'));
        function updateDots(){
          const w = list.clientWidth;
          const idx = Math.round(list.scrollLeft / w);
          dots.forEach((d,i)=>d.setAttribute('aria-current', String(i===idx)));
        }
        list.addEventListener('scroll', ()=>{ window.requestAnimationFrame(updateDots); }, { passive:true });
        dots.forEach((d,i)=>d.addEventListener('click', ()=>{ list.scrollTo({ left: i * list.clientWidth, behavior: 'smooth' }); }));
      }

      // Drag-to-scroll + Autoplay
      let isDown=false, startX=0, startLeft=0, timer=null;
      list.addEventListener('pointerdown', e=>{ isDown=true; startX=e.clientX; startLeft=list.scrollLeft; list.setPointerCapture(e.pointerId); if(timer) clearTimeout(timer); });
      list.addEventListener('pointermove', e=>{ if(!isDown) return; list.scrollLeft = startLeft - (e.clientX - startX); });
      list.addEventListener('pointerup', ()=>{ isDown=false; if (autoplay) tick(); });

      function tick(){
        timer = setTimeout(()=>{
          const maxIdx = items.length - 1;
          const curr = Math.round(list.scrollLeft / list.clientWidth);
          const next = curr >= maxIdx ? 0 : curr + 1;
          list.scrollTo({ left: next * list.clientWidth, behavior: 'smooth' });
          tick();
        }, speed);
      }
      if (autoplay) tick();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
